module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAAAAXNSR0IArs4c6QAAAL5JREFUOBG1k8ENwjAMRVPEBNzhzChcOkrFLkzDIAjUY4ErE7RgnqMgVRVWDW0s/bpx7KfIToKIlOiM5rIToLLg04QQNmhOuypYlFhgU8mglPFCspgKs+pHwZziiLYWwIxTFM1KSNst/oBWVp7G2Y+txT91Ec0q+Own/8BXaPktn/jf4MSXCz+7IbwPHu3xsNi5llyt6LzgX4fnAruvW6/Hba6X1+UaXtD7eENrvUfOiXvS7nriCtWebGeOsvZviDVaQmmX5pwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/lessonmenuiconwhite.png
// module id = 258
// module chunks = 0